import { css } from '@emotion/css'

import { borderRadius, fontSize, fontWeight, spacing } from '../../../styles'
import { shorthandHelper } from '../../../styles/helpers'
import { colors } from '../../../themes'
import { hexToRgba } from '../../../themes/helpers'

const styles = {
  container: size =>
    css({
      boxShadow: `1px 1px 5px ${hexToRgba(colors.black, 0.1)}`,
      padding: spacing.medium,
      border: `1px solid ${hexToRgba(colors.jungleGreen, 0.3)}`,
      borderRadius: borderRadius.default,

      // TODO: Add this light green to Pinata if used more frequently
      backgroundColor: '#F0F8F3',

      display: 'grid',
      gridTemplateColumns: 'min-content auto',
      gridTemplateAreas: size === 'small' ? "'image title' 'content content'" : "'image title' 'image content'",
      columnGap: size === 'small' ? spacing.default : spacing.medium,
    }),

  title: size =>
    css({
      gridArea: 'title',
      color: colors.oxfordBlue,
      fontWeight: fontWeight.semiBold,
      margin: size === 'small' ? 0 : shorthandHelper([spacing.small, 0, spacing.default]),
      fontSize: fontSize.medium,
      alignSelf: size === 'small' && 'center',
    }),

  content: size =>
    css({
      marginTop: size === 'small' && spacing.default,
      fontSize: fontSize.default,
      gridArea: 'content',
      color: colors.scorpion,

      p: {
        margin: 0,
      },

      'p:not(:last-child)': {
        marginBottom: spacing.small,
      },
    }),

  image: css({
    gridArea: 'image',
  }),
}

export default styles
